import { I18n } from '@calendly/i18n';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { ConferenceError } from '../../conference_error';
import { popupSelector, enabledIntegrationsSelector, isPendingSelector, useNewDropdownSelector, isNewEventTypeSelector } from '../selectors';
import { useStateValue } from '../state_provider';
import { GeneralPopup } from './general_popup';
const conferenceInfoCss = "cy19t2n";
const ConferenceInfo = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(conferenceInfoCss, props.className)} />;
});
export const ConferencePopup = () => {
  const state = useStateValue();
  const {
    data: {
      kind
    }
  } = popupSelector(state);
  const enabledIntegrations = enabledIntegrationsSelector(state);
  const isConfigured = enabledIntegrations.includes(kind);
  const isPending = isPendingSelector(state);
  const useNewDropdown = useNewDropdownSelector(state);
  const isNewEventType = isNewEventTypeSelector(state);
  const hideError = useNewDropdown && isNewEventType;
  return <GeneralPopup>
      {isConfigured || hideError ? <ConferenceInfo>
          {I18n.t('publisher.event_types.location.conferencing_configured')}
        </ConferenceInfo> : <ConferenceError kind={kind} hasPendingUser={isPending} />}
    </GeneralPopup>;
};

require("./conference_popup.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./conference_popup.js");